import {css} from '@emotion/css';

export default {
  componentWrapper: css`
    label: marketingSignupEmailCaptureForm;
  `,
  buttonContainer: css`
    label: marketingSignupEmailCaptureForm__buttonContainer;
    display: flex;
    justify-content: center;
  `,
};
